import { call, CallEffect, PutEffect } from "redux-saga/effects";

import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { automaticApi } from "@/settings/api";

export interface Fetch {
  modelId: string;
  brandId: string;
  callback: (success: boolean, errorMessage?: string | unknown) => void;
}

export interface RequestYearsAction {
  type: string;
  payload: Fetch;
}

const uri = "/dominios/v1/veiculo/modelos/anos";

export default function* requestYears({
  payload,
}: RequestYearsAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const body = {
      identificadorModeloVeiculo: payload.modelId,
      identificadorMarcaVeiculo: payload.brandId,
    };

    const response: AxiosResponse = yield call(automaticApi.post, uri, body);

    if (response?.data?.listaAnoModelo?.length > 0) {
      const years = response?.data?.listaAnoModelo.reverse();
      const formattedYears = years.map(
        (item: { anoModeloVeiculo: string }) => ({
          text: item.anoModeloVeiculo,
          value: item.anoModeloVeiculo,
          ...item,
        }),
      );
      yield call(payload.callback, true, formattedYears);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
